<template>
  <OnlyOnClient>
    <div ref="addressBodyRowRef" class="adress__body-row" v-if="template === 'modal'">

      <div class="tabs_titles" :style="{
                '--options': 2,
                '--options-active': activeOptionIndex
              }">
        <div @click="activeOptionIndex = 1" class="tab_title" :class="{active: activeOptionIndex === 1}"
             data-tab="delivery">Доставка
        </div>
        <div @click="activeOptionIndex = 2" class="tab_title" :class="{active: activeOptionIndex === 2}"
             data-tab="pickup">Самовывоз
        </div>
      </div>
      <div class="tabs">
        <div class="tab" :class="{active: activeOptionIndex === 1}" v-if="activeOptionIndex === 1"
             data-tab="delivery">
          <TheFlatShipping @updateShipping="updateShipping" v-model:shipping="shipping">
            <template v-slot:top>
              <div class="tabs_titles tabs_titles_mobile" :style="{
                  '--options': 2,
                  '--options-active': activeOptionIndex
                }">
                <div @click="activeOptionIndex = 1" class="tab_title" :class="{active: activeOptionIndex === 1}"
                     data-tab="delivery">Доставка
                </div>
                <div @click="activeOptionIndex = 2" class="tab_title" :class="{active: activeOptionIndex === 2}"
                     data-tab="pickup">Самовывоз
                </div>
              </div>
            </template>
            <template v-slot:bottom="{ saveAddress }">
              <div class="field__form-bottom">
                <button @click="saveAddress();" class="btn"  type="button">
                  <TheSpinner v-if="isShippingLoading" />
                  Привезти сюда
                </button>
              </div>
            </template>
          </TheFlatShipping>
        </div>
        <div class="tab" :class="{active: activeOptionIndex === 2}" v-if="activeOptionIndex === 2"
             data-tab="pickup">
          <ThePickupShipping :template="template" @updateShipping="updateShipping">
            <template v-slot:top>
              <div class="tabs_titles tabs_titles_mobile" :style="{
                '--options': 2,
                '--options-active': activeOptionIndex
              }">
                <div @click="activeOptionIndex = 1" class="tab_title" :class="{active: activeOptionIndex === 1}"
                     data-tab="delivery">Доставка
                </div>
                <div @click="activeOptionIndex = 2" class="tab_title" :class="{active: activeOptionIndex === 2}"
                     data-tab="pickup">Самовывоз
                </div>
              </div>
            </template>
            <template v-slot:bottom>
              <div class="adress__pickup-bottom" @click="initShipping">
                <button :disabled="isShippingLoading || institution_id === null"
                        :class="{disabled:isShippingLoading || institution_id === null}" class="btn" type="button">
                  <TheSpinner v-if="isShippingLoading" />
                  Заберу здесь
                </button>
              </div>
            </template>
          </ThePickupShipping>
        </div>
      </div>
    </div>
    <div style="margin-bottom: 15px" class="cart__method" v-else>
      <div class="tabs_titles" :style="{
                '--options': 2,
                '--options-active': activeOptionIndex
              }">
        <div @click="activeOptionIndex = 1" class="tab_title" :class="{active: activeOptionIndex === 1}"
             data-tab="delivery">Доставка
        </div>
        <div @click="activeOptionIndex = 2" class="tab_title" :class="{active: activeOptionIndex === 2}"
             data-tab="pickup">Самовывоз
        </div>
      </div>
      <div class="tabs">
        <div class="tab__method" :class="{active: activeOptionIndex === 1}" v-if="activeOptionIndex === 1"
             data-tab="delivery">
          <div class="adress__body">





            <TheFlatShipping v-if="!showModal" @updateShipping="updateShipping" v-model:shipping="shipping" :show-map="false" :isOrderPage="true">
              <template v-slot:top>
                <div class="adress__pickup-radio" style="margin-bottom: 16px" @click="showMyAddressModal = true">
                  <div class="adress__pickup-label" style="justify-content: space-between; border-color: #9A2B0B;">
                    <div style="display: flex; gap: 10px">
                      <div class="adress__pickup-left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                              stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path
                              d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                              stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </div>
                      <div class="adress__pickup-right">
                        <div class="adress__pickup-title" v-if="shipping?.code === 'flat.flat'">  {{getAddressString}}</div>
                        <div class="adress__pickup-title" v-else>Выберите адрес доставки</div>
<div class="adress__pickup-time">{{ currentCity?.name }}</div>
                      </div>
                    </div>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 18L15 12L9 6" stroke="#808183" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </template>
            </TheFlatShipping>
          </div>
        </div>
        <div class="tab__method" :class="{active: activeOptionIndex === 2}" v-if="activeOptionIndex === 2"
             data-tab="pickup">
          <div class="adress__body">
            <ThePickupShipping @updateShipping="updateShipping" :show-map="false">
            </ThePickupShipping>
          </div>
        </div>
      </div>

      <TheModal v-model:show="showMyAddressModal">
        <div class="enter__body modal__body center user-addresses-modal" style="padding: 40px 10px;">
          <div class="modal__close center" @click="showMyAddressModal = false">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.33333 5.33398L26.6667 26.6673M26.6667 5.33398L5.33333 26.6673" stroke="white" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            <div class="enter__body-title">Мои адреса</div>
            <div class="adress__body">
              <div class="adress__pickup-radio" style="margin-bottom: 16px" @click="showMyAddressModal = false; setShowModal(true)">
                <div class="adress__pickup-label" style="justify-content: space-between; border-color: transparent;">
                  <div style="display: flex; gap: 10px">
                    <div class="adress__pickup-left">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                            stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path
                            d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                            stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                    <div class="adress__pickup-right">
                      <div class="adress__pickup-title" v-if="shipping?.code === 'flat.flat'"> {{getAddressString}}</div>
                      <div class="adress__pickup-title" v-else>Выбрать новый адрес</div>
                      <div class="adress__pickup-time">{{ currentCity?.name }}</div>
                    </div>
                  </div>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M4 20H3.25V20.75L4 20.75L4 20ZM4 16L3.46967 15.4697L3.25 15.6893V16H4ZM14.8686 5.13134L14.3383 4.60101L14.3383 4.60101L14.8686 5.13134ZM17.1313 5.13134L16.601 5.66167V5.66167L17.1313 5.13134ZM18.8686 6.8686L19.3989 6.33827V6.33827L18.8686 6.8686ZM18.8686 9.13134L18.3383 8.60101V8.60101L18.8686 9.13134ZM8 20L8 20.75H8.31066L8.53033 20.5303L8 20ZM19.5369 7.691L20.2502 7.45924V7.45924L19.5369 7.691ZM19.5369 8.30895L18.8236 8.07719L19.5369 8.30895ZM15.691 4.46313L15.4592 3.74984L15.691 4.46313ZM16.3091 4.46313L16.5408 3.74984L16.3091 4.46313ZM12.5303 7.46966L12 6.93933L10.9393 7.99999L11.4697 8.53032L12.5303 7.46966ZM15.4697 12.5303L16 13.0607L17.0607 12L16.5303 11.4697L15.4697 12.5303ZM4.75 20V16H3.25V20H4.75ZM4.53033 16.5303L15.399 5.66167L14.3383 4.60101L3.46967 15.4697L4.53033 16.5303ZM16.601 5.66167L18.3383 7.39893L19.3989 6.33827L17.6617 4.60101L16.601 5.66167ZM18.3383 8.60101L7.46967 19.4696L8.53033 20.5303L19.399 9.66167L18.3383 8.60101ZM8 19.25L4 19.25L4 20.75L8 20.75L8 19.25ZM18.3383 7.39893C18.545 7.60569 18.6678 7.72929 18.7517 7.82807C18.8299 7.92016 18.8293 7.94028 18.8236 7.92276L20.2502 7.45924C20.1703 7.21339 20.0336 7.02031 19.8952 6.85729C19.7625 6.70096 19.5882 6.52753 19.3989 6.33827L18.3383 7.39893ZM19.399 9.66167C19.5882 9.47241 19.7625 9.29898 19.8952 9.14264C20.0336 8.97962 20.1703 8.78655 20.2502 8.54072L18.8236 8.07719C18.8293 8.05969 18.8298 8.0798 18.7517 8.17189C18.6678 8.27066 18.5451 8.39426 18.3383 8.60101L19.399 9.66167ZM18.8236 7.92276C18.8399 7.97297 18.8399 8.02698 18.8236 8.07719L20.2502 8.54072C20.3644 8.18924 20.3644 7.81071 20.2502 7.45924L18.8236 7.92276ZM15.399 5.66167C15.6057 5.45492 15.7293 5.33216 15.8281 5.24832C15.9201 5.17015 15.9403 5.17074 15.9228 5.17642L15.4592 3.74984C15.2134 3.82971 15.0204 3.96639 14.8573 4.10478C14.701 4.2375 14.5276 4.41174 14.3383 4.60101L15.399 5.66167ZM17.6617 4.60101C17.4725 4.41179 17.299 4.23753 17.1428 4.10484C16.9798 3.96644 16.7867 3.82972 16.5408 3.74984L16.0773 5.17642C16.0598 5.17072 16.0798 5.1701 16.1719 5.24826C16.2707 5.33212 16.3942 5.45488 16.601 5.66167L17.6617 4.60101ZM15.9228 5.17642C15.973 5.16011 16.0271 5.16011 16.0773 5.17642L16.5408 3.74984C16.1894 3.63563 15.8107 3.63563 15.4592 3.74984L15.9228 5.17642ZM11.4697 8.53032L15.4697 12.5303L16.5303 11.4697L12.5303 7.46966L11.4697 8.53032Z" fill="#808183"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TheShippingMyAdresss  @mapMyAddress="mapMyAddress" />
        </div>
      </TheModal>

    </div>
  </OnlyOnClient>
</template>

<script>
import OnlyOnClient from "@/components/OnlyOnClient.vue";
import TheModal from "@/components/TheModal.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import ThePickupShipping from "@/components/element/order/shipping/ThePickupShipping.vue";
import TheSpinner from "@/components/TheSpinner.vue";
import TheFlatShipping from "@/components/element/order/shipping/TheFlatShipping.vue";
import TheShippingMyAdresss from "@/components/element/order/shipping/TheShippingMyAdresss.vue";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';

export default {
  name: 'TheShippingMethod',
  components: {TheShippingMyAdresss, TheFlatShipping, TheSpinner, ThePickupShipping, TheModal, OnlyOnClient},
  data() {
    return {
      shipping_method: null,
      institution_id: null,
      shipping_address: null,
      showMyAddressModal: false,
    }
  },
  props: {
    template: {
      default: 'modal'
    },
  },
  computed: {
    activeOptionIndex: {
      get() {
        return (this.shippingTabSelected === 'flat.flat') ? 1 : 2;
      },
      set(value) {
        this.setShippingTabSelected((value === 1) ? 'flat.flat' : 'pickup.pickup')
      }
    },
    showModalValue: {
      get() {
        return this.showModal;
      },
      set(value) {
        this.setShowModal(value)
      }
    },
    ...mapGetters({
      'getAddressString': 'shipping/getAddressString'
    }),
    ...mapState({
      'isShippingError': state => state.shipping.error,
      'shippingErrorMessage': state => state.shipping.errorMessage,
      'showModal': state => state.shipping.showModal,
      'cities': state => state.city.cities,
      'city_id': state => state.city.city_id,
      'currentCity': state => state.city.currentCity,
      'shipping': state => state.shipping.shipping,
      'shippingTabSelected': state => state.shipping.shippingTabSelected,
      'isShippingLoading': state => state.shipping.isLoader,
    }),
  },

  mounted() {
    this.setErrorMessage(null);
    this.resetFormErrors();
    if (this.shipping?.code === 'pickup.pickup') {
      this.activeOptionIndex = 2;
    } else {
      this.activeOptionIndex = 1;
    }

    this.$nextTick(() => {
      if (this.$refs.addressBodyRowRef) {
        disableBodyScroll(this.$refs.addressBodyRowRef, {
          reserveScrollBarGap: true,
        })
      }
    })
  },
  watch: {
    'shipping'() {
      if (this.shipping?.code === 'pickup.pickup') {
        this.activeOptionIndex = 2;
      } else {
        this.activeOptionIndex = 1;
      }
    }
  },

  beforeUnmount() {
    if (this.$refs.addressBodyRowRef) {
      enableBodyScroll(this.$refs.addressBodyRowRef)
    }
  },

  methods: {
    ...mapMutations({
      'setError': 'shipping/setError',
      'setErrorMessage': 'shipping/setErrorMessage',
      'setFormErrors': 'shipping/setFormErrors',
      'resetFormErrors': 'shipping/resetFormErrors',
      'setShowModal': 'shipping/setShowModal',
      'setShippingTabSelected': 'shipping/setShippingTabSelected',
    }),
    ...mapActions({
      'setShippingMethod': 'shipping/setShippingMethod'
    }),

    async mapMyAddress(data) {
      await this.updateShipping('flat.flat', data, true);
      if (!this.isShippingError) this.showMyAddressModal = false;
    },
    async updateShipping(method, data, save = false) {
      this.shipping_method = method;
      if (method === 'pickup.pickup') {
        this.institution_id = data;
      } else {
        this.shipping_address = data;
      }
      if (this.template === 'order' || save === true) {
       await this.initShipping().catch(() => {});
      }

    },
    async initShipping() {
      // if (this.isShippingLoading) {
      //   return false;
      // }
      let request = {
        shipping_method: this.shipping_method
      };

      if (this.shipping_method === 'pickup.pickup') {
        request = {
          ...request, institution_id: this.institution_id
        }
      } else {
        request = {
          ...request, shipping_address: this.shipping_address
        }
      }

      await this.setShippingMethod({ data: request});
    }

  },
}
</script>

<style lang="scss">
.user-addresses-modal {
  height: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;

  .adress__pickup-list {
    flex-grow: 1;
    overflow-y: auto;
    border-radius: initial;
  }

  .adress__body-row {
    display: flex;
    flex-direction: column;

    .tabs {
      overflow: hidden;
      flex-grow: 1;

      .tab {
        height: 100%;
      }

      @media (max-width: 1087px) {
        overflow: initial;
      }
    }
  }
}
</style>
